import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectApp, toggleOpenAIChat } from "../../redux/slice/appSlice";

const useAIChatState = () => {
    const dispatch = useAppDispatch();

    const { openAIChat } = useAppSelector(selectApp);
    const toggleAIChat = () => {
        dispatch(toggleOpenAIChat());
    };
    return { openAIChat, toggleAIChat };
};

export default useAIChatState;
